var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5801,
    y: 25.4538,
    width: 3.91667,
    height: 16.0091,
    rx: 1.95833,
    transform: "rotate(45 18.5801 25.4538)",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8257 18.1943L10.7681 18.0215C10.2238 16.3888 10.426 14.5901 11.3115 13.1143C11.7549 12.3753 12.3597 11.7392 13.0769 11.2611L13.3299 11.0925C15.0471 9.94763 17.2703 9.89473 19.0401 10.9566C19.4145 11.1812 19.76 11.451 20.0688 11.7598L20.4922 12.1832C21.7188 13.4098 22.5549 14.9721 22.8951 16.6731L22.961 17.0023C23.0307 17.3507 23.0658 17.7052 23.0658 18.0606L23.0658 18.3374C23.0658 19.5913 23.5639 20.7938 24.4505 21.6805L37.1752 33.1933C38.1627 34.0867 38.2011 35.6249 37.2594 36.5666C36.3178 37.5082 34.7796 37.4698 33.8862 36.4823L22.3734 23.7576C21.5083 22.8925 20.268 22.517 19.0683 22.7569L18.4685 22.8769C17.8468 23.0012 17.2067 23.0012 16.585 22.8769L16.1496 22.7898C14.7903 22.5179 13.5418 21.8498 12.5615 20.8695L12.3456 20.6536C11.6549 19.9629 11.1346 19.1209 10.8257 18.1943Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2915 8.7428L27.4605 14.5738C26.0893 15.945 26.0893 18.1681 27.4605 19.5393V19.5393C28.8317 20.9104 31.0548 20.9104 32.4259 19.5393L38.2569 13.7082",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7744 11.2256L29.9548 17.0452",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.a904315dc3a31e22d438d89f1f26abb1.svg";
export { ForwardRef as ReactComponent };